import type { ReactNode } from 'react';
import { useI18n } from '../i18n';
import styles from './PageChrome.module.css';

type PageChromeProps = {
  title: string;
  onBack: () => void;
  children: ReactNode;
};

export function PageChrome({ title, onBack, children }: PageChromeProps) {
  const { t } = useI18n();

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <button type="button" className={styles.back} onClick={onBack}>
          {t('common.back')}
        </button>
        <h1 className={styles.title}>{title}</h1>
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
